import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  FORCED_DESKTOP_EXPERIENCE,
  FORCED_MOBILE_EXPERIENCE,
  isMobileDevice,
} from "./utils";

export const enumerateDevices = createAsyncThunk(
  "devices/loadDevices",
  async () => navigator.mediaDevices.enumerateDevices(),
);

export const detectMobile = createAsyncThunk<
  boolean,
  { forceDesktop: string | null; forceMobile: string | null }
>("devices/detectMobile", ({ forceDesktop, forceMobile }) => {
  const hasForceDesktopQueryParam = forceDesktop !== null;

  if (hasForceDesktopQueryParam) {
    const shouldForceDesktopExperience = forceDesktop === "true";

    if (shouldForceDesktopExperience) {
      localStorage.setItem(FORCED_DESKTOP_EXPERIENCE, "true");
    } else {
      localStorage.removeItem(FORCED_DESKTOP_EXPERIENCE);
    }
  }

  const hasForceMobileQueryParam = forceMobile !== null;

  if (hasForceMobileQueryParam) {
    const shouldForceMobileExperience = forceMobile === "true";

    if (shouldForceMobileExperience) {
      localStorage.setItem(FORCED_MOBILE_EXPERIENCE, "true");
    } else {
      localStorage.removeItem(FORCED_MOBILE_EXPERIENCE);
    }
  }

  return isMobileDevice();
});

export const askDevicesPermissions = createAsyncThunk(
  "devices/askPermissions",
  async (constraints: MediaStreamConstraints, { dispatch }) => {
    const stream = await navigator.mediaDevices.getUserMedia(constraints);

    dispatch(enumerateDevices());

    return stream;
  },
);
